export default __webpack_public_path__ + "static/799-26540242acaf21db15169bc753a0f026.gif";